'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SocialLogos = require('./SocialLogos');

var _SocialLogos2 = _interopRequireDefault(_SocialLogos);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SocialLogos2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurflineFooter/SocialLogos/index.js
// module id = 329
// module chunks = 0